module.exports = __webpack_public_path__ + "static/media/test_loading_loop.6efd4a42.png";